function Dialog(dialogEl, overlayEl) {

    this.dialogEl = dialogEl;
    this.overlayEl = overlayEl;
    this.focusedElBeforeOpen;

    var focusableEls = this.dialogEl.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    this.focusableEls = Array.prototype.slice.call(focusableEls);

    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[ this.focusableEls.length - 1 ];

    this.close(); // Reset
}


Dialog.prototype.open = function() {

    var Dialog = this;

    document.getElementsByTagName('body')[0].classList.add('open');

    this.dialogEl.removeAttribute('aria-hidden');
    this.overlayEl.removeAttribute('aria-hidden');

    this.focusedElBeforeOpen = document.activeElement;

    this.dialogEl.addEventListener('keydown', function(e) {
        Dialog._handleKeyDown(e);
    });

    this.overlayEl.addEventListener('click', function() {
        Dialog.close();
    });

    this.firstFocusableEl.focus();
};

Dialog.prototype.close = function() {

    document.getElementsByTagName('body')[0].classList.remove('open');

    this.dialogEl.setAttribute('aria-hidden', true);
    this.overlayEl.setAttribute('aria-hidden', true);

    if ( this.focusedElBeforeOpen ) {
        this.focusedElBeforeOpen.focus();
    }
};


Dialog.prototype._handleKeyDown = function(e) {

    var Dialog = this;
    var KEY_TAB = 'Tab';
    var KEY_ESC = 'Escape';

    function handleBackwardTab() {
        if ( document.activeElement === Dialog.firstFocusableEl ) {
            e.preventDefault();
            Dialog.lastFocusableEl.focus();
        }
    }
    function handleForwardTab() {
        if ( document.activeElement === Dialog.lastFocusableEl ) {
            e.preventDefault();
            Dialog.firstFocusableEl.focus();
        }
    }

    switch(e.key) {
        case KEY_TAB:
            if ( Dialog.focusableEls.length === 1 ) {
                e.preventDefault();
                break;
            }
            if ( e.shiftKey ) {
                handleBackwardTab();
            } else {
                handleForwardTab();
            }
            break;
        case KEY_ESC:
            Dialog.close();
            break;
        default:
            break;
    }


};

Dialog.prototype.addEventListeners = function(openDialogSel, closeDialogSel) {

    var Dialog = this;

    var openDialogEls = document.querySelectorAll(openDialogSel);
    for ( var i = 0; i < openDialogEls.length; i++ ) {
        openDialogEls[i].addEventListener('click', function() {
            Dialog.open();
        });
    }

    var closeDialogEls = document.querySelectorAll(closeDialogSel);
    for ( var i = 0; i < closeDialogEls.length; i++ ) {
        closeDialogEls[i].addEventListener('click', function() {
            Dialog.close();
        });
    }

};

// handle show/hide header while scrolling up and down
function stickyNavigation() {
    const bodyEl = document.querySelector('body');
    const siteHeader = document.querySelector('.site-header');
    let prevScrollPos = window.pageYOffset;
    let siteHeaderHeight = siteHeader.offsetHeight;
    let style = getComputedStyle(siteHeader);
    siteHeaderHeight += parseInt(style.marginTop) + parseInt(style.marginBottom);
    const gallerySidebar = document.querySelector('.sidebar-content');
    // document.documentElement.style.setProperty('--nav-height', `-${siteHeaderHeight}px`);
    let currScrollPos = window.pageYOffset;
    if (currScrollPos > 0) {
        bodyEl.classList.add('scrolled');
    } else {
        bodyEl.classList.remove('scrolled');
    }
    window.addEventListener('scroll', () => {
        currScrollPos = window.pageYOffset;
        if (currScrollPos > 0) {
            bodyEl.classList.add('scrolled');
        } else {
            bodyEl.classList.remove('scrolled');
        }
        if (currScrollPos > prevScrollPos && currScrollPos > siteHeaderHeight) {
            if (siteHeader.classList.contains('nav-down')) {
                siteHeader.classList.remove('nav-down');
            }
            siteHeader.classList.add('nav-up');
            if (gallerySidebar) {
                gallerySidebar.style.top = '45px';
            }
        } else {
            if (currScrollPos > siteHeaderHeight && currScrollPos + window.innerHeight < document.body.clientHeight) {
                if (siteHeader.classList.contains('nav-up')) {
                    siteHeader.classList.remove('nav-up');
                }
                siteHeader.classList.add('nav-down');
                if (gallerySidebar) {
                    gallerySidebar.style.top = '132px';
                }
            } else {
                if (siteHeader.classList.contains('nav-up')) {
                    siteHeader.classList.remove('nav-up');
                }
                if (siteHeader.classList.contains('nav-down')) {
                    siteHeader.classList.remove('nav-down');
                }
            }
        }
        prevScrollPos = currScrollPos;
    });
}

document.addEventListener('DOMContentLoaded', () => {

    console.log('hi dom 👋');

    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.expand = 300; // default 360-500
    lazySizesConfig.expFactor = 1.5; // default: 1.7

    // call sticky navigation function
    stickyNavigation();

    // global nav dialog
    const navDialogEl = document.querySelector('.dialog');
    const dialogOverlay = document.querySelector('.dialog-overlay');
    let myDialog = new Dialog(navDialogEl, dialogOverlay);
    myDialog.addEventListeners('.open-dialog', '.close-dialog');

    // gallery filter dialog
    const filterDialogEl = document.querySelector('.filter-dialog');
    const filterDialogOverlay = document.querySelector('.filter-dialog-overlay');
    if (filterDialogEl && filterDialogOverlay) {
        let filterDialog = new Dialog(filterDialogEl, filterDialogOverlay);
        filterDialog.addEventListeners('.open-filter-dialog', '.close-filter-dialog');
    }

    const answerGroups = document.querySelectorAll('.answer-group');
    const answers = document.querySelectorAll('.answers');
    const prevAnswerButton = document.querySelectorAll('.prev-group');
    if (answerGroups) {
        answerGroups.forEach(answerGroup => {
           const restartBtn = answerGroup.querySelector('.restart');
           if (restartBtn) {
               restartBtn.addEventListener('click', (e) => {
                   let btnEl = e.target;
                   // console.log(btnEl);
                   let btnElParent = btnEl.parentNode.parentNode;
                   // console.log(btnElParent);
                   let firstSibling = btnElParent.parentNode.firstElementChild;
                   showHideAnswers (btnElParent, firstSibling);
               });
           }
        });
    }
    if (answers) {
        answers.forEach(answer => {
            answer.addEventListener('click', function(e) {
                e.preventDefault();
                let el = e.target;
                // console.log(el);
                let elParent = el.parentNode;
                let elDataAttr = el.getAttribute('data-answers');
                let nextAnswer = document.querySelector(`[data-answer-target=${elDataAttr}]`);
                showHideAnswers (elParent, nextAnswer);
            });
        });
    }
    function showHideAnswers (currentAnswer, nextAnswer){
        if (currentAnswer) {
            currentAnswer.style.display = 'none';
            currentAnswer.setAttribute('tabindex', '-1');
            currentAnswer.setAttribute('aria-hidden', 'true');
        }
        if (nextAnswer) {
            nextAnswer.style.display = 'block';
            nextAnswer.setAttribute('tabindex', '1');
            nextAnswer.setAttribute('aria-hidden', 'false');
        }
    }

    const anchor = document.querySelector('#filter-top');
    const pages = document.querySelectorAll('.page-item:not(.disabled)');
    if (anchor && pages) {
        for(let i = 0; i<pages.length; i++) {
            pages[i].addEventListener('click', function(){
                anchor.scrollIntoView(
                    {
                        behavior: 'smooth', // Defines the transition animation. default: auto
                    }
                );
            });
        }
    }

    // dynamically import Lazy Background Video Module
    const lazyVideo = document.querySelector('.lazy-bg-video');
    if (lazyVideo) {
        import ('./utils/LazyBackgroundVideo-wrapper.js');
    }
});